import React, { useContext } from 'react';
import S from "./Risk.styled";
import CardHeader from "../CardHeader";
import FundContext from "@/components/FundSingle/FundProvider";
import Star from '@/assets/star.svg';
import StarFilled from '@/assets/star-filled.svg';
import Table from '../../../Table/index';
import moment from 'moment';

const RiskAndRating: React.FC<FundSingle> = () => {
    const { fundRiskDetails, externalLinkMorningstarMethod } = useContext(FundContext);

    if (Object.keys(fundRiskDetails).length === 0 || !fundRiskDetails.RiskAndRating) {
        return null;
    }

    const riskAndRating = fundRiskDetails.RiskAndRating;
    const methodLink = externalLinkMorningstarMethod;
    let latestDate = '';

    const renderStars = (rating: number) => {
        return Array.from({ length: 5 }, (_, i) =>
            i < rating ? <StarFilled key={i} /> : <Star key={i} />
        );
    };

    const convertMonthStringToYears = (monthString: string) => {
        switch (monthString) {
            case 'M36': return '3 år';
            case 'M60': return '5 år';
            case 'M120': return '10 år';
            case 'M255': return 'Övergripande';
            default: return monthString;
        }
    };

    const convertRatingToWord = (rating: number) => {
        switch (rating) {
            case 1: return 'Låg';
            case 2: return 'Under Medel';
            case 3: return 'Medel';
            case 4: return 'Över Medel';
            case 5: return 'Hög';
            default: return rating.toString();
        }
    };

    const tableRows: [string, React.ReactNode[]][] = riskAndRating.map((rating: any) => {
        latestDate = moment(rating.Date).format('YYYY-MM-DD');
        return [
            convertMonthStringToYears(rating.TimePeriod),
            [
                convertRatingToWord(rating.PerformanceRatingValue),
                convertRatingToWord(rating.RiskRatingValue),
                renderStars(rating.RatingValue)
            ]
        ];
    });

    // if (methodLink) {
    //     tableRows.push([
    //         'Kategori: Sverige',
    //         [' ', ' ', <a href={methodLink} target="_blank" rel="noopener noreferrer">Klicka här för att se vår metod</a>]
    //     ]);
    // }

    const tableData = {
        headings: ['', 'AVKASTNING', 'RISK (REL KAT)', 'RATING'],
        rows: tableRows
    };

    return (
        <S.RiskWrapper>
            <CardHeader title="Morningstar rating (relativt kategori)" subTitle={latestDate} />
            <Table tableData={tableData} />
        </S.RiskWrapper>
    );
};

export default RiskAndRating;
